import {inject} from '@angular/core';
import {CanActivateFn} from '@angular/router';
import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {LocaleService} from '../shared/locale/locale.service';
import {ShowcaseContextService} from '../utils/showcase-context.service';
import {ShowcaseService} from './showcase.service';

/**
 * Перед активацией showcase-роутов (до первых контент-запросов) читает `targetLocales`
 * витрины из `/showcase/{hash}` и конфигурирует `LocaleService`: форс единственного
 * языка (EN-only → весь контент EN) и видимость свитчера. `getShowcaseInfo` кэширован
 * (shareReplay) → реактивации мгновенны, без лишних запросов; шапка переиспользует
 * тот же ответ. fail-open: при отсутствии hash / ошибке оставляем дефолтное двуязычное
 * поведение (guard не блокирует навигацию).
 *
 * Гард на корневом showcase-роуте отрабатывает раньше, чем активируются layout/шапка/
 * каталог, поэтому к моменту первого XHR контента локаль уже выставлена.
 */
export const showcaseLocaleGuard: CanActivateFn = (): Observable<boolean> | boolean => {
  const ctx = inject(ShowcaseContextService);
  const locale = inject(LocaleService);
  if (!ctx.hash) {
    return true;
  }
  return inject(ShowcaseService).getShowcaseInfo().pipe(
    map(info => {
      locale.configureForShowcase(info?.targetLocales);
      return true;
    }),
    catchError(() => of(true)),
  );
};
